<ul class="ms-nav">
  <input #input type="checkbox" id="ms-menu" class="ms-menu-toggle" name="ms-menu-toggle" />

  <div class="bg-change"></div>
  @for (item of buttons; track item; let i = $index) {
    <ng-container *checkPermission="item.permission">
      <li class="createElementsList ms-li">
        <a ngbTooltip="{{item.tooltipMessageKey || '' | translate}}" container="body"
          tooltipClass="apc-tooltip-left" placement="left"  triggers="hover" class="add ico" (click)="createNew(item.key)"
          [class.hideButtons]="!iconsExpanded">
          <span class="d-flex align-items-center">
            <div class="icon fill-white toggle-icons" aria-label=item.key [inlineSVG]=item.svg></div>
          </span>
        </a>
      </li>
    </ng-container>
  }
  @if (showButton) {
    <li class="ms-main">
      <a>
        <label class="ms-menu-toggle-lbl" for="ms-menu">
          <div (click)="expand()" style="height: 100%;">
            <div class="icon" aria-label="plus" [inlineSVG]="'assets/ico/plus-regular.svg'"></div>
          </div>
        </label>
      </a>
    </li>
  }
</ul>